import { toJS } from 'mobx';
import UserStore from 'mobx/UserStore';
import { useMemo } from 'react';

export const refCenter = {
  lat: 13.757703,
  lng: 100.52032,
};

export function useMapsCenter() {
  const centered = useMemo(() => {
    const locations = toJS(UserStore.organization.location);
    const hasLocations = locations?.coordinates?.filter((x) => x)?.length > 1 || false;
    if (hasLocations) {
      const coordinates = locations?.coordinates.reverse();
      const t = { lat: coordinates?.[0], lng: coordinates?.[1] };
      return t;
    } else {
      return refCenter;
    }
  }, []);

  return {
    centered,
  };
}
